module.exports = __webpack_public_path__ + "img/CL.abc1422a.svg";